import { render, staticRenderFns } from "./stepVideoStyle.vue?vue&type=template&id=0d6f5c18&scoped=true&"
import script from "./stepVideoStyle.vue?vue&type=script&lang=ts&"
export * from "./stepVideoStyle.vue?vue&type=script&lang=ts&"
import style0 from "./stepVideoStyle.vue?vue&type=style&index=0&id=0d6f5c18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f5c18",
  null
  
)

export default component.exports